import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from "moment";
import CFTaskContacts from "./contacts";
import CFTaskComments from "./comment";
import CFTaskHistory from "./taskHistory";
import CFProjectHistory from "./projectHistory";
import {Accordion, Card} from "react-bootstrap";
import './CFTaskDetailModal.css';
import {
  CF_ADMIN_ROLE_ID,
  HOLDER_ADMIN_ROLE_ID,
} from '../../../../lib/appConstants';
class CFTaskDetailModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      projectInsured: {
        status: '',
        url: '',
      }
    }
  }

  getDocumentInfo = () => {
    const {document} = this.props;
    if (document) {
      return <a target='_blank' href={document.DocumentUrl}>{document.FileName}</a>
    }
  }

  getComplianceStatus = () => {
    const {ProjectId, assetTypeId, id} = this.props.task;
    if (!id) return false;

    const {projectsInsuredsList, document} = this.props;

    let taskComplianceStatus = null;
    let taskProjectInsuredId = null;

    if (assetTypeId == 8) {
      taskProjectInsuredId = document.projectInsuredId
      taskComplianceStatus = document.DocumentStatus;
    } else if (projectsInsuredsList[0] && ProjectId) {
        const projectInsured = projectsInsuredsList[0];
        taskProjectInsuredId = projectInsured.ProjectInsuredID;
        taskComplianceStatus = projectInsured.ComplianceStatusName;
    }
    if (taskComplianceStatus && taskProjectInsuredId) {
      return <a target={'_blank'} href={'certfocus/certificates/' + taskProjectInsuredId}>{taskComplianceStatus}</a>
    }
  }

  getInsured = () => {

    const {assetTypeId, InsuredId, insuredName, id} = this.props.task;
    if (!id) return false;

    const {document} = this.props;

    let taskInsuredName = '';
    let taskInsuredId = '';
    if (assetTypeId == 8 && document.SubcontractorID) { //project/insured task
      taskInsuredId = document.SubcontractorID;
      taskInsuredName = document.insuredName;
    } else {
        taskInsuredId = InsuredId;
        taskInsuredName = insuredName;
    }

    if (taskInsuredName && taskInsuredId) {
      return <a target={'_blank'} href={`certfocus/insureds/${taskInsuredId}`}>{taskInsuredName}</a>
    }

    return '';

  }

  render() {
    const { handleTaskSubmit, handleCommentSubmit, closeAndNew, onHide, taskHistory, projectHistory, login } = this.props;
    const {holder, insured, action, projectNumber, dateDue, projectName, document, status, comment} = this.props.locale.labels;
    const {holderName, type, HolderId, ProjectId} = this.props.task;
    const taskDateDue = this.props.task.dateDue;
    const taskProjectName = this.props.task.projectFullName;
    const taskProjectNumber = this.props.task.projectNumber;
    let userCanCloseTask = false; 

    let contact = [];
    const { holderContact, insuredContact, agencyContact,agentContact} = this.props.task;
    if (holderContact) {
      contact = JSON.parse(holderContact);
    }
    if(insuredContact) {
      contact = contact.concat(JSON.parse(insuredContact));
    }
    if(agencyContact) {
      contact = contact.concat(JSON.parse(agencyContact));
    }
    if(agentContact) {
      contact = contact.concat(JSON.parse(agentContact));
    }

    const contactList = contact.concat(this.props.contacts)

    let taskDescription = '';
    if (this.props.task.originalComment) {
      taskDescription = this.props.task.originalComment.split('\n').map((item, i) => {
        return <p key={i} className={'m-0'}>{item}</p>;
      });
    }

    if (this.props.task) {
      const { profile } = login;
      const { assignedToUserId, assignedToRoleId } = this.props.task;
      const userId = profile.Id;
      const roleId = profile.CFRoleId;

      if ((roleId === CF_ADMIN_ROLE_ID) ||
        (roleId === HOLDER_ADMIN_ROLE_ID) ||
        (assignedToUserId && assignedToUserId === userId) ||
        (assignedToRoleId && assignedToRoleId === roleId))
      {
        userCanCloseTask = true;
      }
      //console.log('userCanCloseTask: ', userCanCloseTask);
    }

    return (
      (this.props.task ?
        <React.Fragment>
          <div className={'taskDetail'}>
            <div className="row">
              <header>
                <div className={'title'}>{this.props.locale.title}</div>
              </header>
            </div>

            <div className="row">
              <div className="col-4"><span className='font-weight-bold'>{holder}:</span> <a target={'_blank'}
                                                  href={`certfocus/holders/${HolderId}`}>{holderName}</a></div>
              <div className="col-4"><span className='font-weight-bold'>{insured}:</span> {this.getInsured()}</div>
              <div className="col-4"><span className='font-weight-bold'>{action}:</span> <strong>{type}</strong></div>
            </div>
            <div className="row">
              <div className="col-4"><span className='font-weight-bold'>{projectNumber}:</span> <a target={'_blank'}
                                                         href={`certfocus/projects/${ProjectId}`}>{taskProjectNumber}</a>
              </div>
              <div className="col-4"><span className='font-weight-bold'>{projectName}:</span> <a target={'_blank'}
                                                       href={`certfocus/projects/${ProjectId}`}>{taskProjectName}</a>
              </div>
              <div className="col-4"><span className='font-weight-bold'>{dateDue}:</span> <span
                className="text-danger">{moment(taskDateDue).format('MM/DD/YYYY')}</span></div>
            </div>
            <div className="row">
              <div className="col-8"><span className='font-weight-bold'>{document}:</span> {this.getDocumentInfo()}</div>
              <div className="col-4"><span className='font-weight-bold'>{status}:</span> {this.getComplianceStatus()}</div>
            </div>
            <div className="row">
              <div className="col-12"><span className='font-weight-bold'>{comment}:</span> <br/> {taskDescription}</div>
            </div>
            {/*<hr/>*/}
            {/*Files attached*/}
            <br/>
            <CFTaskContacts
              contactList={contactList}
              onHide={onHide}
              closeAndNew={closeAndNew}
              handleTaskSubmit={handleTaskSubmit}
              userCanCloseTask={userCanCloseTask}
            />

            <Accordion>
              <Card>
                <Accordion.Toggle as={Card.Header} eventKey="1">
                  Task's Internal Actions
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <CFTaskComments
                      handleCommentSubmit={handleCommentSubmit}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>


            {(projectHistory.length > 0) ?
              <React.Fragment>

                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1">
                      {this.props.locale.projectHistory}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        <CFProjectHistory
                          locale={this.props.locale.history}
                          history={projectHistory}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </React.Fragment>
              : null
            }

            {(taskHistory.length > 0) ?
              <React.Fragment>
                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1">
                      {this.props.locale.taskHistory}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        <CFTaskHistory
                          locale={this.props.locale.history}
                          history={taskHistory}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </React.Fragment>
              : null
            }
          </div>
        </React.Fragment>
        : '')
    );
  }
}

CFTaskDetailModal.propTypes = {
  task: PropTypes.object.isRequired,
  handleTaskSubmit: PropTypes.func.isRequired,
  closeAndNew: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};


const mapStateToProps = ((state) => {
  return {
    login: state.login,
    locale: state.localization.strings.CFTasks.viewDetail,
    contacts: state.contacts.list,
    documentsList: state.documents.list,
    projectsInsuredsList: state.projectInsureds.list,
  };
})

export default connect(mapStateToProps)(CFTaskDetailModal);